<template>
    <div class="lymphomap_auth_center login_main_popup">
        <div class="lymphomap_auth">
            <span class="popup_close_icon" v-if="loginPopupCross">
                <i aria-hidden="true" class="fa fa-times-circle" @click="popupCloseEventMethod"></i>
            </span>
            <div class="login_box_small">
                <form @submit.prevent="validateLoginBeforeSubmit">
                    <div class="login_form_inner">
                        <div class="form-group">
                            <input type="text" v-validate="'required'" placeholder="Mobile / Email*" v-model="identity"
                                name="identity" class="form-control"
                                v-bind:class="{ 'is-invalid': errors.has('identity') }" data-vv-as="Email"
                                autocomplete="off" @keyup="emailErrorHideMethod">
                            <small class="invalid-feedback" v-if="errors.has('identity') && validationEmailErr">
                                Enter your email or mobile phone number</small>
                            <!-- <template v-else>
              <small class="invalid-feedback d-block invalid_field_error" v-if="loginEmailFieldError && !submitted">
                <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                Please provide your registered email address or mobile number
              </small>
            </template> -->
                        </div>
                        <div class="form-group pw_field_for_eye_icon">
                            <template v-if="password.length > 0">
                                <i class="fa fa_eye_c"
                                    :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"
                                    aria-hidden="true" @mouseover="showPassword = true"
                                    @mouseleave="showPassword = false"></i>
                            </template>
                            <template v-if="showPassword">
                                <input type="text"
                                    v-validate="{ required: true, min: 8, regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/ }"
                                    placeholder="Password*" v-model="password" name="password" class="form-control"
                                    v-bind:class="{ 'is-invalid': errors.has('password') }" data-vv-as="password"
                                    autocomplete="off" @keyup="passwordErrorHideMethod">
                            </template>
                            <template v-else>
                                <input type="password"
                                    v-validate="{ required: true, min: 8, regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/ }"
                                    placeholder="Password*" v-model="password" name="password" class="form-control"
                                    v-bind:class="{ 'is-invalid': errors.has('password') }" data-vv-as="password"
                                    autocomplete="off" @keyup="passwordErrorHideMethod">
                            </template>
                            <small class="invalid-feedback" v-if="errors.has('password') && validationPwErr">Enter your
                                password</small>
                            <template v-else>
                                <small class="invalid-feedback d-block invalid_field_error"
                                    v-if="loginPwFieldError && !submitted">
                                    <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                                    <template v-if="attemptErrorCount == '1'">Your entered Password is incorrect. Please
                                        try again. </template>
                                    <template v-else-if="attemptErrorCount == '2'">Your entered Password is still
                                        incorrect. Please try again or click on
                                        <span class="already_account">
                                            <router-link :to="{ name: 'requestPasswordReset' }">forgot
                                                password</router-link>
                                        </span>.</template>
                                    <template v-else-if="attemptErrorCount == '3'">Your entered Password is still
                                        incorrect. Please click on
                                        <span class="already_account">
                                            <router-link :to="{ name: 'requestPasswordReset' }">forgot
                                                password</router-link>
                                        </span>.</template>
                                    <template v-else>Login attempt exceeded more than 3 times! Please click on <span
                                            class="already_account">
                                            <router-link :to="{ name: 'requestPasswordReset' }">forgot
                                                password</router-link>
                                        </span> to reset.</template>
                                </small>
                            </template>
                        </div>
                        <div class="form-group">
                            <label class="accept_terms_label">
                                <span class="accept_terms_text">By clicking on login, you are agree to our terms and
                                    condition
                                    as mentioned in <router-link to="/member/agreement/" target="_blank">member
                                        agreement.</router-link>
                                </span>
                            </label>
                        </div>
                        <div class="row align-items-center pt-1">
                            <div class="col">
                                <button type="submit" class="btn btn-auth btn-block"
                                    :disabled="submitted">Login</button>
                            </div>
                        </div>
                        <!-- <small class="invalid-feedback mt-3 d-block invalid_field_error" v-if="userInActiveError && !submitted">
            <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i> Wait for account approval by Admin Lymphomap.
          </small> -->
                        <div class="already_account">
                            <router-link :to="{ name: 'requestPasswordReset' }">Forgot Password</router-link>
                        </div>
                        <div class="already_account">
                            <router-link to="/signup/">Don't have an account? Sign up now</router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <deactivated-user-for-popup v-if="deactivatedUserForPopupState"></deactivated-user-for-popup>
        <user-account-approval-for-popup v-if="userAccountApprovalForPopupState"></user-account-approval-for-popup>
    </div>
</template>


<script>
/*eslint-disable */
import { bus } from '@/main';
import deactivatedUserForPopup from '@/components/authentication/deactivated-user-for-popup/';
import toast from '@/services/toast';
import userAccountApprovalForPopup from '@/components/authentication/user-account-approval-for-popup/';

export default {
    name: 'main-login-form-popup',

    components: {
        'deactivated-user-for-popup': deactivatedUserForPopup,
        'user-account-approval-for-popup': userAccountApprovalForPopup
    },

    data() {
        return {
            redirectTo: null,
            redirectToHash: null,
            password: '',
            identity: '',
            submitted: false,

            loginEmailFieldError: false,
            loginPwFieldError: false,

            attempt: 1,
            attemptErrorCount: 1,

            loginPopupCross: true,
            showPassword: false,

            userInActiveError: false,
            validationPwErr: false,
            validationEmailErr: false,

            deactivatedUserForPopupState: false,
            userAccountApprovalForPopupState: false
        };
    },

    computed: {
        redirectToHashFull() {
            return `${this.redirectTo || ''}${this.redirectToHash || ''}`;
        }
    },

    mounted() {
        this.redirectTo = this.$route.query.redirect;
        this.redirectToHash = this.$route.hash;

        this.loginPopupCross = this.$route.name !== 'loginMainPage';

        bus.$on('deactivatedUserForPopupStateBus', this.handleDeactivatedUser);
        bus.$on('userAccountApprovalForPopupStateBus', this.handleApprovalUser);
    },

    beforeDestroy() {
        bus.$off('deactivatedUserForPopupStateBus', this.handleDeactivatedUser);
        bus.$off('userAccountApprovalForPopupStateBus', this.handleApprovalUser);
    },

    methods: {
        handleDeactivatedUser(data) {
            this.deactivatedUserForPopupState = data;
        },

        handleApprovalUser(data) {
            this.userAccountApprovalForPopupState = data;
        },

        emailErrorHideMethod() {
            this.loginEmailFieldError = false;
            this.userInActiveError = false;
            this.validationEmailErr = false;
        },

        passwordErrorHideMethod() {
            this.loginPwFieldError = false;
            this.userInActiveError = false;
            this.validationPwErr = false;
        },

        async validateLoginBeforeSubmit() {
            this.validationEmailErr = true;
            this.validationPwErr = true;

            const isValid = await this.$validator.validateAll();
            if (!isValid) return;

            this.submitted = true;
            this.attemptErrorCount = this.attempt;

            this.$store.commit('loader/START_LOADING');

            try {
                const res = await this.$store.dispatch('loginUserWithPwAction', {
                    identity: this.identity,
                    password: this.password,
                    type: 'web',
                    attempt: this.attempt
                });

                await this.$store.dispatch('authUserAgreementFun', {
                    user: res.data.data.user.email,
                    from_page: 'login'
                });

                this.handleRedirect();

                this.loginEmailFieldError = false;
                this.loginPwFieldError = false;

                toast.success(res.data.msg || 'Request processed successfully.');
            } catch (err) {
                this.$store.commit('loader/FORCE_STOP');
                this.handleLoginError(err);
            } finally {
                this.submitted = false;
            }
        },

        handleRedirect() {
            if (this.redirectToHashFull) {
                const parts = this.redirectToHashFull.split('/');

                if (parts[parts.length - 1] === '') {
                    this.$router.push('/home/');
                } else {
                    this.$router.push({ path: this.redirectToHashFull });
                }
            } else {
                this.$router.push('/home/');
            }
        },

        handleLoginError(err) {
            const error = err && err.data.error || {};
            const data = err && err.data.data || {};

            if (error.attempt) {
                this.attempt = 1;
                toast.error(error.attempt);
                this.loginPwFieldError = true;
            } else {
                this.attempt++;
            }

            if (error.password) this.loginPwFieldError = true;
            if (error.identity) this.loginEmailFieldError = true;

            if (data.is_active === false) {
                this.userAccountApprovalForPopupState = true;
                document.body.classList.add('popup_open_body');
            }

            if (data.is_deleted === false) {
                this.deactivatedUserForPopupState = true;
                document.body.classList.add('popup_open_body');
            }
        },

        popupCloseEventMethod() {
            bus.$emit('mainLoginFormPopupStateBus', false);
        }
    }
};
</script>


<style lang="scss" scoped>
.login_main_popup {
    align-items: center;
    height: 100dvh;
    position: absolute;
    top: 0;
    left: -40px;
    right: -40px;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    padding: 40px 30px;
    text-align: left;
    display: flex;

    .login_box_small {
        max-width: 320px;
        margin: 0 auto;
    }

    .lymphomap_auth {
        max-width: 500px;
        margin: auto;
        padding: 75px 15px;
        font-family: 'Lato', sans-serif;
        color: #fff;
        width: 100%;

        @media only screen and (max-width:1023px) {
            padding: 75px 30px;
        }

        .popup_close_icon {
            position: absolute;
            right: 40px;
            top: 50px;

            .fa {
                color: #ffe400;
                font-size: 30px;
                cursor: pointer;

                &:hover {
                    color: #87cefa;
                }
            }
        }

        .invalid-feedback {
            color: #ff2400;
            font-size: 16px;
            text-align: center;
            margin-top: 10px;

            &.invalid_field_error {
                font-size: 18px;
                color: #ff2400;
                position: relative;
                padding-left: 22px;

                .fa-exclamation-triangle {
                    position: absolute;
                    left: 0px;
                    top: 5px;
                }
            }
        }

        .btn-auth {
            font-family: 'ACETONE';
            background: none;
            border: 2px solid #ffe400;
            color: #ffe400;
            text-transform: uppercase;
            font-size: 28px;
            padding: 8px 0;
            line-height: 1;
            height: auto;
            min-width: 110px;
            border-radius: 6px;
            box-shadow: none !important;
            outline: none !important;

            &:hover {
                background: #ffe400;
                color: #000000;
            }
        }

        .form-control {
            height: 100%;
            width: 100%;
            height: 52px;
            font-weight: normal;
            font-size: 18px;
            border-radius: 5px;
            padding: 0 20px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: none;
            outline: none !important;
            box-shadow: none !important;
            color: #ffd400;
            background: rgba(255, 255, 255, 0.08);

            &:focus,
            &.active {
                border: 1px solid #ffd400;
            }

            &::placeholder,
            &::-webkit-input-placeholder,
            &::-moz-placeholder {
                color: rgba(255, 255, 255, 0.3);
            }

            &:focus::-webkit-input-placeholder {
                font-size: 0;
            }

            &:focus::-moz-placeholder {
                font-size: 0;
            }
        }

        .login_form_inner {
            label {
                font-size: 16px;
                font-family: Arial, Helvetica, sans-serif;
            }

            .form-group {
                margin-bottom: 30px;
            }
        }
    }

    .already_account {
        text-align: center;
        margin-top: 30px;

        a {
            color: #00ff60;
            font-size: 18px;
            text-decoration: none;

            &:hover {
                color: #ffe400;
            }
        }
    }

    .resent_otp_txt {
        color: #00ff60;
        margin-top: 10px;
        display: block;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 16px;
    }

    .resend_otp_txt {
        color: #00ff60;
        font-size: 16px;
        font-family: Arial, Helvetica, sans-serif;

        span {
            cursor: pointer;

            &:hover {
                color: #ffe400;
            }
        }

        a {
            color: #00ff60 !important;
            text-decoration: none;

            &:hover {
                color: #ffe400 !important
            }
        }
    }

    .accept_terms_text {
        display: block;
        text-align: justify;

        a {
            color: #00ff60;
            text-decoration: none;

            &:hover {
                color: #ffe400;
            }
        }
    }

    .pw_field_for_eye_icon {
        position: relative;

        .fa_eye_c {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 28px;
            cursor: pointer;
            color: #ffe400;
        }
    }
}
</style>